/**
 * useAsconProdDays — 경원(아스콘) 기간 생산 일정 요약 (내 업무 홈 다가오는 일정·일정 달력, 2026-10-22).
 *
 * OKIS 미러 수주(asconShipmentRepo.fetchOrders)를 한 번 읽어 날짜별 요약(domain/mySchedule asconProdDays)으로 바꾼다.
 * 오늘·앞날 = 수주량, 지난 날 = 출하누계. 구독·폴링 없음(useJoongangSchedule 과 같은 방식).
 * enabled=false(권한 없음·소속 아님) 또는 기간이 비면 아무것도 읽지 않는다.
 */
import { useEffect, useMemo, useState } from "react";
import { kstToday } from "@/domain/rqc";
import { asconProdDays, type ProdDay } from "@/domain/mySchedule";
import { asconShipmentRepo } from "@/services/asconShipment.repository";

interface Result {
  key: string;
  days: ProdDay[];
  error: string | null;
}

const EMPTY: ProdDay[] = [];

export function useAsconProdDays(enabled: boolean, from: string, to: string) {
  const key = enabled && from && to && from <= to ? `${from}~${to}` : "";
  const [res, setRes] = useState<Result | null>(null);

  useEffect(() => {
    if (!key) return;
    const [a, b] = key.split("~");
    let alive = true;
    asconShipmentRepo.fetchOrders(a, b).then(
      (r) => { if (alive) setRes({ key, days: asconProdDays(r.orders, kstToday(), r.source === "mock"), error: null }); },
      (e: unknown) => {
        if (!alive) return;
        const msg = e instanceof Error ? e.message : String(e);
        setRes({ key, days: EMPTY, error: msg.includes("permission") ? "경원 출하 자료를 볼 권한이 없습니다" : "생산 일정을 불러오지 못했습니다." });
      },
    );
    return () => { alive = false; };
  }, [key]);

  const cur = key && res && res.key === key ? res : null;
  const byDate = useMemo(() => new Map((cur?.days ?? EMPTY).map((d) => [d.date, d])), [cur]);
  return {
    days: cur?.days ?? EMPTY,
    byDate,
    loading: Boolean(key) && !cur,
    error: cur?.error ?? null,
  };
}
